import { IconProps } from "@/wc/components";
import { h } from "omi";

export function UserIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 19 21">
      <path
        d="M6.38469 1.2679c2-.509429 7.86791-.698112 9.32071 1.07547 1.0378 1.26415.9623 3.79246 1.0755 5.33963.3019 4 1.7925 10.2264-3.283 11.566-3.2264.8491-8.49056.9057-10.67924-2.0566C.026203 13.4188 1.34696 2.70187 6.64884 1.34338"
        stroke="#667085"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9694 13.2678c.0755-.1509-.5471.4151-.6981.5472-.5094.434-1.1321.8302-1.83017.8491-1.83019.0566-3.54717-1.1698-3.92453-3M6.32823 7.30566c-.01887.56604-.05661 1.13208-.09434 1.69812M12.8941 7.70166c-.1132.60377-.2641 1.20754-.3585 1.81132"
        stroke="#667085"
        stroke-width="1.6"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
